import { Injectable, Injector } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { EMPTY, Observable, catchError, finalize, throwError } from 'rxjs';
import { LoadingService } from '../../services/loading/loading.service';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {

  private activeRequests = 0;

  constructor(private loadingService: LoadingService,
              private router: Router,
              private injector: Injector) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const skipHeader = request.headers.has('X-Skip-Global-Loader');
    const trackLoader = !skipHeader && !request.url.includes('invoices/summary');

    if (trackLoader) {
      if (this.activeRequests === 0) {
        this.loadingService.setLoaderValue(true);
      }
      this.activeRequests++;
    }

    if (skipHeader) {
      request = request.clone({ headers: request.headers.delete('X-Skip-Global-Loader') });
    }

    return next.handle(request).pipe(
      finalize(() => {
        if (trackLoader) {
          this.activeRequests--;
          if (this.activeRequests === 0) {
            this.loadingService.setLoaderValue(false);
          }
        }
      }),
      catchError((requestError: HttpErrorResponse) => {

        if (requestError.error.status === 'Token is Expired' && requestError.status === 403) {
          this.injector.get(AuthService).clearAuthState();
          this.router.navigate(['/']);
          return EMPTY
        }

        return throwError(() => requestError);
      })
    );
  }
}
